"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgb = hexToRgb;
exports.parseColor = parseColor;
exports.luminance = luminance;
exports.contrastRatio = contrastRatio;
function hexToRgb(hex) {
    const raw = hex.trim().replace(/^#/, '');
    const expanded = raw.length === 3
        ? raw
            .split('')
            .map((c) => c + c)
            .join('')
        : raw;
    if (!/^[a-f\d]{6}$/i.test(expanded))
        return null;
    return {
        r: parseInt(expanded.slice(0, 2), 16),
        g: parseInt(expanded.slice(2, 4), 16),
        b: parseInt(expanded.slice(4, 6), 16),
    };
}
// Hex or opaque rgb()/rgba(). Translucent and named colors return null —
// their effective contrast depends on what is behind them.
function parseColor(color) {
    const rgb = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*([\d.]+)\s*)?\)$/i.exec(color.trim());
    if (!rgb)
        return hexToRgb(color);
    if (rgb[4] !== undefined && Number(rgb[4]) < 1)
        return null;
    const channels = [rgb[1], rgb[2], rgb[3]].map(Number);
    if (channels.some((value) => value > 255))
        return null;
    const [r, g, b] = channels;
    return { r, g, b };
}
/** @see https://www.w3.org/TR/WCAG20/#relativeluminancedef */
function srgbToLinear(c255) {
    const c = c255 / 255;
    if (c <= 0.04045) {
        return c / 12.92;
    }
    return Math.pow((c + 0.055) / 1.055, 2.4);
}
/** Relative luminance (0-1) of a hex color, or null if the hex is invalid. */
function luminance(hex) {
    const rgb = parseColor(hex);
    if (!rgb)
        return null;
    const R = srgbToLinear(rgb.r);
    const G = srgbToLinear(rgb.g);
    const B = srgbToLinear(rgb.b);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}
/** WCAG 2.0 contrast ratio (1-21) between two hex colors, or null if either is invalid. */
function contrastRatio(hex1, hex2) {
    const L1 = luminance(hex1);
    const L2 = luminance(hex2);
    if (L1 === null || L2 === null)
        return null;
    const lighter = Math.max(L1, L2);
    const darker = Math.min(L1, L2);
    return (lighter + 0.05) / (darker + 0.05);
}
